 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonp"];
 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length) {
 			resolves.shift()();
 		}
 		if(executeModules) {
 			for(i=0; i < executeModules.length; i++) {
 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
 			}
 		}
 		return result;
 	};

 	// The module cache
 	var installedModules = {};

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		134: 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData === 0) {
 			return new Promise(function(resolve) { resolve(); });
 		}

 		// a Promise means "currently loading".
 		if(installedChunkData) {
 			return installedChunkData[2];
 		}

 		// setup Promise in chunk cache
 		var promise = new Promise(function(resolve, reject) {
 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunkData[2] = promise;

 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = "text/javascript";
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "js/" + ({"1":"Spinner","2":"Hero","3":"Carousel","4":"LoadMore","5":"LiveStat","6":"OfferCard","7":"GameTypeLabels","8":"Rating","9":"IconSignal","10":"GameCardComing","11":"GameCard","12":"OfferBadges","13":"GameCardSm","14":"GameCardMd","15":"FiltersToolbar","16":"CasinoStatsList","17":"CasinoInfoList","18":"GameCardSimple","19":"GamesPlay","20":"Profile","21":"InsightCard","22":"IconPlayed","23":"HeroFeaturedGame","24":"Featured","25":"FavouriteSupplier","26":"FavouriteOffer","27":"FavouriteCasino","28":"Map","29":"Home","30":"ProfileNav","31":"ModalFilters","32":"MapWorld","33":"CasinoFeed","34":"NotFound","35":"Casinos","36":"TermsAndConditions1","37":"PrivacyPolicy1","38":"TermsAndConditions0","39":"PrivacyPolicy0","40":"UserFavouriteSuppliers","41":"UserFavouriteOffers","42":"UserFavouriteGames","43":"UserFavouriteCasinos","44":"User","45":"Suppliers","46":"SupplierMobile","47":"Offers","48":"OfferMobile","49":"NewsArticle","50":"News","51":"Games","52":"CasinoMobile","53":"SupplierGameFilters","54":"StatCircle","55":"OfferCardMd","56":"ModalVideo","57":"InsightSlide","58":"IconTime","59":"FilterBar","60":"FeedStatus","61":"FeedOffer","62":"FeedArticle","63":"FavouritesNavMobile","64":"Expandable","65":"DrawerListItem","66":"Countdown","67":"CasinoLocations","68":"CasinoImages","79":"FavouriteGame","82":"GameTypeIcon","83":"ButtonToggle","84":"CasinoSign","85":"Favourite","87":"UserFavourites","88":"Dropdown","90":"NewsCard","91":"Drone","92":"CountdownStamp","93":"SupplierCard","94":"Timer","95":"SearchResultsList","96":"OffersBuilding","97":"NewsCardPopular","98":"ChooseCasino","99":"BrickCasino","100":"Brick","101":"BlankCard","104":"OfferCardSm","105":"GameLoader","106":"StatusCardSm","107":"CasinoCard","108":"NewsBuilding","109":"GameError","110":"DockGameCasinos","111":"GameCardComingMd","112":"CasinoCardSimple","113":"Toolbar","114":"Spaceship","115":"ShareToTwitter","116":"ShareToFacebook","117":"SearchExpand","118":"Pager","119":"OrderedList","120":"OffersCallout","121":"GamesCta","122":"GameMobile","123":"GameFilters","124":"GameDesktop","125":"GameApiLoader","126":"FeaturedGameCard","127":"Docket","128":"Dock","129":"CasinoTypes","130":"CasinoProfileDocket","131":"CasinoFilters","132":"BrickOffer","133":"NewsGrid"}[chunkId]||chunkId) + "." + {"0":"355d84","1":"ad0a44","2":"1a73d4","3":"359896","4":"11cce5","5":"a4f3c6","6":"b9faab","7":"31ffcb","8":"786553","9":"6d113c","10":"a3f579","11":"a25cde","12":"fde628","13":"909149","14":"0b4ae8","15":"0130fb","16":"f52f73","17":"c9d6eb","18":"1d666a","19":"1799b4","20":"f63599","21":"22e9d3","22":"cec7c8","23":"d9ba3b","24":"9b2351","25":"d688c7","26":"795c28","27":"1fac73","28":"626e39","29":"11ce03","30":"514434","31":"4ea0fa","32":"eee781","33":"4a8eb0","34":"755161","35":"b6522e","36":"bacf98","37":"4df534","38":"c94a4c","39":"879da9","40":"70b042","41":"af6aee","42":"f3205b","43":"868a11","44":"23852b","45":"518552","46":"67f4ab","47":"d5f2cc","48":"9bd545","49":"667c8c","50":"c3145d","51":"e7a0f1","52":"d4ba2a","53":"1a4b13","54":"9947a6","55":"c38bcf","56":"347503","57":"6cafeb","58":"9735d9","59":"70949d","60":"48c5d6","61":"1680eb","62":"ff16e5","63":"e18806","64":"57b435","65":"d0d584","66":"d0a2a0","67":"1ba2af","68":"ac0b41","75":"e9bae2","76":"e74298","77":"cddeb3","78":"a04dae","79":"df2d64","80":"b59ab7","81":"457d37","82":"431530","83":"60bdb3","84":"4ade77","85":"f067d2","86":"1712e2","87":"0bcad3","88":"a7d6a4","89":"61bcda","90":"912ead","91":"7dbe5b","92":"e93d83","93":"d61cd8","94":"f2e951","95":"88bfdc","96":"3d628b","97":"c0da1a","98":"62b32c","99":"5334c5","100":"7e4a4e","101":"8bc770","102":"a9541a","103":"7f4638","104":"c96bc7","105":"4890aa","106":"5c0c59","107":"0de9cd","108":"2764a1","109":"d73e46","110":"505a3a","111":"d19717","112":"9fd745","113":"93981d","114":"4724be","115":"72d7a5","116":"142cb4","117":"7cda63","118":"1c554a","119":"945125","120":"4ff258","121":"afc4f0","122":"fce1b2","123":"e3f703","124":"ac10aa","125":"75c075","126":"e3053f","127":"6ea416","128":"b6f9d0","129":"d772ad","130":"87e6a9","131":"34f9f4","132":"05bec1","133":"95e5d0"}[chunkId] + ".js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) {
 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				}
 				installedChunks[chunkId] = undefined;
 			}
 		};
 		head.appendChild(script);

 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };



// WEBPACK FOOTER //
// webpack/bootstrap 2a341815e9e187355315